// extracted by mini-css-extract-plugin
export default {"alert":"_2hFtS8Scpal-KnX1bsi26L","support":"_368-7lqA1BfKsgPFHWYzV"};